import { Button } from "@components/ui/button";
import { getTableInfo } from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { useNavigate } from "react-router";
import ProfileForm from "./form/index.form";
import { useSelectionStore } from "@utils/states/index.state";

const index = () => {
  const pathname = usePathname();
  const result = getTableInfo({
    mode: "default",
    type: pathname || "",
  }) as { title: string; description: string };
  let { title, description } = result;

  const navigate = useNavigate();
  const { isFormPending } = useSelectionStore();
  return (
    <>
      <div className="flex justify-between max-sm:flex-col items-center p-2 ">
        <ul className="list-none">
          {<li className="text-[32px] font-[500]">{title}</li>}
          {<li className="text-[#7B7679] text-[14px]">{description}</li>}
        </ul>
        <div className="flex gap-2 items-center">
          {" "}
          <Button
            variant={"outline"}
            onClick={() => {
              navigate(-2);
            }}
          >
            Cancel
          </Button>
          <Button disabled={isFormPending} form="profile" variant={"default"}>
            {isFormPending ? "Pending.... " : " Submit Changes"}
          </Button>
        </div>
      </div>
      <ProfileForm />
    </>
  );
};

export default index;
